export const createEmptyAddressForm = () => ({
  street: '',
  city: '',
  postalCode: '',
  country: '',
});

const normalizeAddressField = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const normalizeAddressForm = (address) => ({
  street: address?.street || '',
  city: address?.city || '',
  postalCode: address?.postalCode || '',
  country: address?.country || '',
});

export const buildAddressPayload = (address) => {
  const normalized = {
    street: normalizeAddressField(address?.street),
    city: normalizeAddressField(address?.city),
    postalCode: normalizeAddressField(address?.postalCode),
    country: normalizeAddressField(address?.country),
  };

  const entries = Object.entries(normalized).filter(([, value]) => value);
  return entries.length ? Object.fromEntries(entries) : undefined;
};
